define( [
	"./document"
], function( document ) {
	"use strict";

	return document.documentElement;
} );



/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/src/var/documentElement.js
 ** module id = 191
 ** module chunks = 0
 **/